module.exports = __webpack_public_path__ + "img/logo-comdirect.1bf7abba.png";